import axios from "./http";
import {
  BlockProcedureDto,
  BlockProcedureSearchRequest,
  UpsertBlockProcedureDto
} from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/block-procedures`;

export const searchBlockProcedures = (blockProceduresSearchRequest: Partial<BlockProcedureSearchRequest>,
                                      source: CancelTokenSource): Promise<Array<BlockProcedureDto>> => {
  return axios
      .post(`${apiUri}/search`, blockProceduresSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const getUpsertBlockProcedureById = (id: number, source: CancelTokenSource): Promise<UpsertBlockProcedureDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const saveBlockProcedure = (upsertBlockProcedureDto: Partial<UpsertBlockProcedureDto>, source: CancelTokenSource): Promise<BlockProcedureDto> => {
  return axios
      .post(`${apiUri}`, upsertBlockProcedureDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editBlockProcedure = (id: number, upsertBlockProcedureDto: Partial<UpsertBlockProcedureDto>, source: CancelTokenSource): Promise<BlockProcedureDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertBlockProcedureDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteBlockProcedure = (id: number, source: CancelTokenSource): Promise<BlockProcedureDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
